<template>
  <div class="box">
    <b-loading
      v-if="isLoading"
      :is-full-page="false"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="has-text-weight-bold">Editar Informações Principais</h2>
    <br />

    <div class="columns">
      <!-- Foto do Perfil -->
      <div class="column is-narrow">
        <div
          class="logo-upload-div"
          style="cursor: pointer"
          :style="{ 'background-image': `url(${previewImage})` }"
          @click="$refs.fileInput.click()"
        >
          <b-icon
            icon="camera-retro"
            size="is-large"
            style="position: relative; left: 23px; top: 12px; color: #999"
            v-if="!previewImage"
          ></b-icon>
          <p
            class="has-text-centered"
            style="font-size: 0.8rem; position: relative; top: 6px; color: #999"
            v-if="!previewImage"
          >
            Logo PNG
          </p>
        </div>

        <p class="has-text-centered delete-user-image" @click="deleteUserImage">
          <u>Excluir foto</u>
        </p>

        <input
          ref="fileInput"
          type="file"
          @input="pickFile"
          style="display: none"
          accept="image/png"
        />
      </div>
      <div class="columns userName">
        <b-field
          style="width: 100%"
          :label="account.name ? 'Nome' : ''"
          label-position="on-border"
        >
          <b-input v-model="account.name" placeholder="Nome" expanded>
          </b-input>
        </b-field>

        <b-field
          style="width: 100%"
          :label="account.surname ? 'Sobrenome' : ''"
          label-position="on-border"
        >
          <b-input v-model="account.surname" placeholder="Sobrenome" expanded>
          </b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <b-field
        :label="account.state ? 'UF' : ''"
        label-position="on-border"
        class="userUF"
      >
        <b-autocomplete
          v-model="account.state"
          :data="filteredStatesArray"
          :open-on-focus="true"
          :keep-first="true"
          placeholder="UF"
          @select="(option) => (selected = option)"
        >
          <template slot="empty"> Sem resultados </template>
        </b-autocomplete>
      </b-field>

      <b-field
        :label="account.city ? 'Cidade' : ''"
        label-position="on-border"
        style="width: 100%; margin-right: 1rem"
      >
        <b-autocomplete
          v-model="account.city"
          :data="filteredCitiesArray"
          :open-on-focus="true"
          :keep-first="true"
          placeholder="Cidade"
          @select="(option) => (selected = option)"
          :disabled="!isValidState"
        >
          <template slot="empty"> Sem resultados </template>
        </b-autocomplete>
      </b-field>
    </div>

    <div class="columns">
      <b-field
        :label="account.university ? 'Universidade' : ''"
        label-position="on-border"
        class="userUniversity"
      >
        <b-autocomplete
          v-model="account.university"
          :data="filteredUniversitiesArray"
          :open-on-focus="true"
          :keep-first="true"
          placeholder="Universidade"
          @select="(option) => (selected = option)"
          :disabled="!isValidState"
        >
          <template slot="empty"> Sem resultados </template>
        </b-autocomplete>
      </b-field>
    </div>

    <div class="columns">
      <b-field
        :label="account.course ? 'Curso' : ''"
        label-position="on-border"
        class="userCourse"
      >
        <b-autocomplete
          v-model="account.course"
          :data="filteredCoursesArray"
          :open-on-focus="true"
          :keep-first="true"
          placeholder="Curso"
          @select="(option) => (selected = option)"
        >
          <template slot="empty"> Sem resultados </template>
        </b-autocomplete>
      </b-field>

      <b-field style="margin-top: 0.5rem; margin-right: 1rem; width: 20rem">
        <span class="button is-static control">Formatura</span>

        <b-select v-model="account.graduationDate" expanded>
          <option value="">Formatura</option>
          <option v-for="(year, i) in graduationYearOptions()" :key="i">
            {{ year }}
          </option>
        </b-select>
      </b-field>
    </div>

    <h2 class="has-text-weight-bold">Meus Contatos</h2>
    <br />

    <div class="columns unity2">
      <b-field
        style="width: 100%; margin-left: 0.5rem"
        :label="account.cellphone ? 'Celular' : ''"
        label-position="on-border"
      >
        <b-select placeholder="DDD" v-model="account.areacode">
          <option v-for="(ddd, i) in ddds" :value="ddd" :key="i">
            {{ ddd }}
          </option>
        </b-select>

        <b-input
          placeholder="Celular"
          expanded
          v-model="account.cellphone"
        ></b-input>
      </b-field>

      <b-field
        style="width: 100%; margin-right: 1rem; margin-left: 0.5rem"
        label="E-mail"
        label-position="on-border"
      >
        <b-input
          v-model="account.originalEmail"
          placeholder="E-mail"
          expanded
          disabled
        >
        </b-input>
      </b-field>
    </div>

    <div class="columns unity">
      <b-field style="width: 100%; margin: 0.5rem 1rem 0 0.5rem">
        <span class="button is-static">facebook.com/</span>

        <b-input
          expanded
          placeholder="Facebook do Estudante"
          v-model="userFace"
        ></b-input>
      </b-field>
    </div>

    <div class="columns unity">
      <b-field style="width: 100%; margin: 0.5rem 1rem 0 0.5rem">
        <span class="button is-static">instagram.com/</span>

        <b-input
          expanded
          placeholder="Instagram do Estudante"
          v-model="userInsta"
        ></b-input>
      </b-field>
    </div>

    <div class="columns unity">
      <b-field style="width: 100%; margin: 0.5rem 1rem 0 0.5rem">
        <span class="button is-static">linkedin.com/in/</span>

        <b-input
          expanded
          placeholder="Linkedin do Estudante"
          v-model="userLinkedin"
        ></b-input>
      </b-field>
    </div>

    <div v-if="account.isOrganizationLeader">
      <h2 class="has-text-weight-bold">
        Informações da minha Organização Estudantil
      </h2>
      <br />

      <div class="columns unity">
        <b-field
          style="width: 100%; margin: 0 1rem 0 0.5rem"
          label="Nome da OE"
          label-position="on-border"
        >
          <b-input
            expanded
            placeholder="Nome da OE"
            v-model="oe.name"
            disabled
          ></b-input>
        </b-field>
      </div>

      <div class="columns unity">
        <b-field
          style="width: 100%; margin: 0.5rem 1rem 0 0.5rem"
          label="Categoria da OE"
          label-position="on-border"
        >
          <b-select
            expanded
            placeholder="Categoria da OE"
            v-model="oe.category"
            disabled
          >
            <option value="">Categoria da Organização Estudantil</option>
            <option value="Aerodesign">Aerodesign</option>
            <option value="AIESEC">AIESEC</option>
            <option value="Atlética Universitária">
              Atlética Universitária
            </option>
            <option value="Baja">Baja</option>
            <option value="Barco Solar">Barco Solar</option>
            <option value="Centro Acadêmico">Centro Acadêmico</option>
            <option value="Clube de Consultoria">Clube de Consultoria</option>
            <option value="Clube de Empreendedorismo">
              Clube de Empreendedorismo
            </option>
            <option value="Coletivo">Coletivo</option>
            <option value="Cursos Populares">Cursos Populares</option>
            <option value="Diretório Acadêmico">Diretório Acadêmico</option>
            <option value="Eficiência Energética">Eficiência Energética</option>
            <option value="Empresa Júnior">Empresa Júnior</option>
            <option value="Enactus">Enactus</option>
            <option value="Engenheiros sem Fronteiras">
              Engenheiros sem Fronteiras
            </option>
            <option value="Equipe de Foguetes">Equipe de Foguetes</option>
            <option value="Evento">Evento</option>
            <option value="Feira de Carreiras">Feira de Carreiras</option>
            <option value="Fórmula">Fórmula</option>
            <option value="Grupo de Estudos">Grupo de Estudos</option>
            <option value="Grupo de Extensão">Grupo de Extensão</option>
            <option value="Grupo de Pesquisa">Grupo de Pesquisa</option>
            <option value="IEEE">IEEE</option>
            <option value="Liga Acadêmica">Liga Acadêmica</option>
            <option value="Liga de Mercado Financeiro">
              Liga de Mercado Financeiro
            </option>
            <option value="ONG">ONG</option>
            <option value="PET (Programa de Educação Tutorial)">
              PET (Programa de Educação Tutorial)
            </option>
            <option value="Robótica">Robótica</option>
            <option value="Semana de Curso">Semana de Curso</option>
            <option value="separador" disabled>-------------</option>
            <option value="Outra">Outros Grupos</option>
          </b-select>
        </b-field>
      </div>

      <div class="columns unity">
        <b-field
          style="width: 100%; margin: 0.5rem 1rem 0 0.5rem"
          :label="account.position ? 'Posição na OE' : ''"
          label-position="on-border"
        >
          <b-input
            placeholder="Posição na OE"
            v-model="account.position"
          ></b-input>
        </b-field>

        <b-field
          style="width: 100%; margin: 0.5rem 1rem 0 0.5rem"
          label="E-mail institucional da OE"
          label-position="on-border"
        >
          <b-input
            placeholder="E-mail Institucional da OE"
            disabled
            v-model="oe.organizationEmail"
          >
          </b-input>
        </b-field>
      </div>
    </div>
    <hr />

    <Pendencies :pendencies="pendencies" />

    <div class="columns">
      <div class="column"></div>

      <div class="column is-narrow">
        <b-button
          class="button is-danger is-rounded is-pulled-left"
          @click="confirmAccountDeletion"
          outlined
        >
          Excluir conta
        </b-button>

        <span class="is-pulled-left">
          &nbsp;&nbsp;&nbsp;
        </span>

        <button
          class="button is-primary is-rounded is-pulled-left"
          @click="updateAccount"
          :disabled="pendencies.length > 0"
        >
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { estados } from "../../../assets/js/estados";
import { cidades_por_estado } from "../../../assets/js/cidades-por-estado";
import { universidades_por_estado } from "../../../assets/js/universidades-por-estado";
import { cursos } from "../../../assets/js/cursos";
import { ddds } from "../../../assets/js/ddds";
import { responsive } from "../../../mixins/responsive";
import { commom } from "../../../mixins/commom";
import Pendencies from "../../commom/Pendencies";

export default {
  name: "FormGeneralInfo",

  props: ["account"],

  mixins: [responsive, commom],

  components: {
    Pendencies,
  },

  data() {
    return {
      isLoading: false,
      previewImage: null,
      statesList: [],
      citiesList: {},
      universitiesList: {},
      coursesList: [],
      ddds: [],
      userFace: "",
      userInsta: "",
      userLinkedin: "",
      graduationMonth: "",
      graduationYear: "",
      file: null,
    };
  },

  methods: {
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          this.previewImage = e.target.result;
        };
        reader.readAsDataURL(file[0]);
        this.file = file[0];
      }
    },

    setSocialMedia() {
      if (this.account.facebook) {
        this.userFace = this.account.facebook.split("/")[3];
      }
      if (this.account.insta) {
        this.userInsta = this.account.insta.split("/")[3];
      }
      if (this.account.linkedin) {
        this.userLinkedin = this.account.linkedin.split("/")[4];
      }
    },

    updateAccount() {
      this.isLoading = true;

      if (this.userFace) {
        this.account.facebook = "https://facebook.com/" + this.userFace;
      } else {
        this.account.facebook = "";
      }

      if (this.userInsta) {
        this.account.insta = "https://instagram.com/" + this.userInsta;
      } else {
        this.account.insta = "";
      }

      if (this.userLinkedin) {
        this.account.linkedin = "https://linkedin.com/in/" + this.userLinkedin;
      } else {
        this.account.linkedin = "";
      }

      if (this.graduationMonth && this.graduationYear) {
        this.account.graduationDate =
          this.graduationMonth + "/" + this.graduationYear;
      } else {
        this.account.graduationDate = "";
      }

      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("account", JSON.stringify(this.account));

      this.$store
        .dispatch("updateAccount", formData)
        .then((res) => {
          if (res.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: "Sucesso!",
              message: "As informações do seu perfil foram atualizadas! 😉",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa"
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    confirmAccountDeletion() {
      this.$buefy.dialog.confirm({
        message: "Tem certeza que deseja excluir sua conta?",
        type: "is-danger",
        cancelText: "Cancelar",
        confirmText: "Sim, excluir",
        onConfirm: () => this.deleteAccount()
      });
    },

    deleteAccount() {
      this.isLoading = true;
      this.$store
        .dispatch("deleteAccount")
        .then(res => {
          if (res.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: "Sucesso!",
              message:
                "Sua conta foi deletada. Você será redirecionado para a página inicial.",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa",
              onConfirm: () => {
                this.$store.dispatch("logout");
                this.$router.replace("/");
              }
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    graduationYearOptions() {
      let years = [];
      let today = new Date();
      let semester = 0;
      if (today.getMonth() <= 5) {
        semester = 1;
      } else {
        semester = 2;
      }
      if (semester == 1) {
        years.push(today.getFullYear() + "." + 1);
        years.push(today.getFullYear() + "." + 2);
      } else {
        years.push(today.getFullYear() + "." + 2);
      }
      for (let i = 1; i <= 6; i++) {
        years.push(today.getFullYear() + i + "." + 1);
        years.push(today.getFullYear() + i + "." + 2);
      }
      years.push("Já estou formado");
      return years;
    },

    deleteUserImage() {
      if (!this.previewImage) {
        this.$buefy.toast.open({
          message: "Não existe imagem",
          type: "is-warning"
        });
        return false;
      }
      this.isLoading = true;
      this.$store
        .dispatch("deleteUserImage")
        .then(res => {
          if (res.data.result === "ok") {
            this.previewImage = null;
            this.$buefy.toast.open({
              message: "Imagem deletada",
              type: "is-success"
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    filteredStatesArray() {
      return this.statesList.filter((option) => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.account.state.toLowerCase()) >= 0
        );
      });
    },

    isValidState() {
      return this.statesList.includes(this.account.state);
    },

    filteredCitiesArray() {
      let filteredCitiesArray = [];
      if (this.isValidState) {
        filteredCitiesArray = this.citiesList[this.account.state].filter(
          (option) => {
            return (
              option
                .toString()
                .toLowerCase()
                .indexOf(this.account.city.toLowerCase()) >= 0
            );
          }
        );
      }
      return filteredCitiesArray;
    },

    filteredUniversitiesArray() {
      let filteredUniversitiesArray = [];
      if (this.isValidState) {
        filteredUniversitiesArray = this.universitiesList[
          this.account.state
        ].filter((option) => {
          return (
            option
              .toString()
              .toLowerCase()
              .indexOf(this.account.university.toLowerCase()) >= 0
          );
        });
      }
      return filteredUniversitiesArray;
    },

    filteredCoursesArray() {
      let filteredCoursesArray = [];
      filteredCoursesArray = this.coursesList.filter((option) => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.account.course.toLowerCase()) >= 0
        );
      });
      return filteredCoursesArray;
    },

    oe() {
      return this.$store.state.organization.organization;
    },

    pendencies() {
      const pendencies = [];

      if (this.account.name == "") {
        pendencies.push("Nome");
      }

      if (this.account.surname == "") {
        pendencies.push("Sobrenome");
      }

      if (this.account.state == "") {
        pendencies.push("UF (Estado)");
      }

      if (this.account.city == "") {
        pendencies.push("Cidade");
      }

      if (this.account.university == "") {
        pendencies.push("Universidade");
      }

      if (this.account.course == "") {
        pendencies.push("Curso");
      }

      if (this.account.areacode == "") {
        pendencies.push("DDD");
      }

      if (this.account.cellphone == "") {
        pendencies.push("Celular");
      }

      if (this.account.position == "") {
        pendencies.push("Posição na OE");
      }

      return pendencies;
    }
  },

  mounted() {
    this.previewImage = this.account.picture
      ? this.account.picture
      : this.account.googlePictureURL;
    this.statesList = estados;
    this.citiesList = cidades_por_estado;
    this.universitiesList = universidades_por_estado;
    this.coursesList = cursos;
    this.ddds = ddds;
    this.setSocialMedia();
  }
};
</script>

<style scoped>
.box {
  padding: 2rem 2rem;
  max-width: 800px !important;
  margin: auto;
}
.logo-upload-div {
  width: 96px;
  height: 96px;
  border: 1px solid #999;
  color: #999;
  border-radius: 50%;
  background-size: cover;
  background-position: center center;
}
.logoEditing {
  border: solid gray 0.5px;
  border-radius: 100%;
  background-color: white;
  width: 1.8rem;
  height: 1.8rem;
  margin-left: auto;
  margin-bottom: -10rem;
}
.logoEditing .icon {
  display: block;
  margin-left: auto;
  margin-right: auto;
  color: gray;
}
.userName {
  width: 100%;
  margin: 1rem;
  display: block !important;
}
.userUF {
  margin-right: 0.5rem;
  margin-left: 0.5rem;
}
.userUniversity {
  width: 100%;
  margin-left: 0.5rem;
  margin-right: 1rem;
}
.userCourse {
  margin-left: 0.5rem;
  margin-right: 1rem;
  margin-top: 0.5rem;
  width: 100%;
}

.delete-user-image {
  font-size: 80%;
  color: red;
  cursor: pointer;
}

@media (max-width: 769px) {
  .logo-upload-div {
    margin-left: auto;
    margin-right: auto;
  }
  .userName {
    margin: 0;
  }
  .userUF {
    margin-left: 0;
    margin-right: 0;
    margin-top: 1.5rem;
  }
  .userUniversity {
    margin-left: 0;
    margin-right: 0;
    margin-top: 1.5rem;
  }
  .userCourse {
    margin-left: 0;
    margin-right: 0;
    margin-top: 1.5rem;
  }
  .unity {
    margin-top: 0.5rem;
    margin-left: -1.3rem;
    margin-right: -0.2rem;
  }
  .unity2 {
    margin-left: -1.3rem;
    margin-right: -0.2rem;
  }
}

@media (max-width: 450px) {
  .box {
    padding: 2rem 1.5rem;
  }
}
</style>
